import QRCode from 'qrcode';

interface EpcQrCodeParams {
    name: string;       // Beneficiary name (max 70 chars)
    iban: string;       // IBAN
    bic?: string;       // BIC (optional for SEPA)
    amount: number;     // Amount in EUR
    reference: string;  // Payment reference (max 35 chars, used as remittance info)
}

/**
 * Generate an EPC QR-Code (GiroCode) as a PNG data URL.
 *
 * EPC QR-Code format (European Payments Council standard):
 * Line 1: Service Tag (BCD)
 * Line 2: Version (002)
 * Line 3: Character Set (1 = UTF-8)
 * Line 4: Identification (SCT)
 * Line 5: BIC of beneficiary
 * Line 6: Name of beneficiary (max 70 chars)
 * Line 7: IBAN of beneficiary
 * Line 8: Amount (EUR + amount, e.g. EUR1234.56)
 * Line 9: Purpose (empty)
 * Line 10: Remittance reference (structured, max 35 chars)
 * Line 11: Remittance text (unstructured, max 140 chars)
 * Line 12: Beneficiary to originator info (empty)
 */
export const generateEpcQrCodeDataUrl = async (params: EpcQrCodeParams): Promise<string> => {
    const { name, iban, bic, amount, reference } = params;

    // Build EPC payload
    const lines = [
        'BCD',                                      // Service Tag
        '002',                                      // Version
        '1',                                        // Character Set (UTF-8)
        'SCT',                                      // Identification
        bic || '',                                  // BIC
        name.substring(0, 70),                      // Beneficiary name
        iban.replace(/\s/g, ''),                    // IBAN (strip spaces)
        `EUR${amount.toFixed(2)}`,                  // Amount
        '',                                         // Purpose
        '',                                         // Structured remittance reference (empty)
        reference.substring(0, 140),                // Unstructured remittance text
        '',                                         // Beneficiary to originator info
    ];

    const payload = lines.join('\n');

    return QRCode.toDataURL(payload, {
        errorCorrectionLevel: 'M',
        margin: 1,
        width: 150,
    });
};
